import { render } from "./SchedaAggiunto.vue?vue&type=template&id=5e76ffba"
import script from "./SchedaAggiunto.vue?vue&type=script&lang=js"
export * from "./SchedaAggiunto.vue?vue&type=script&lang=js"

import "./SchedaAggiunto.vue?vue&type=style&index=0&id=5e76ffba&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__